<template>
  <div class="home">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1 class="hero-title"><span class="highlight">Leo-Martin</span></h1>
          <p class="hero-subtitle">{{ $t('home.profession') }}</p>
          <div class="hero-cta">
            <RouterLink to="/projects" class="btn btn-primary">{{ $t('home.ctaButton') }}</RouterLink>
            <RouterLink to="/contact" class="btn btn-outline">{{ $t('nav.contact') }}</RouterLink>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router'

export default {
  name: 'HomeView',
  components: {
    RouterLink
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding: 0;
  position: relative;
  z-index: 1;
}

.hero {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  padding: 6rem 0;
  
  &-content {
    max-width: 800px;
    margin: 0 auto;
    padding: 4rem;
    background-color: var(--color-card-bg);
    border-radius: 24px;
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px var(--color-shadow);
    position: relative;
    z-index: 2;
    transform: translateY(-2rem);
    animation: fadeInUp 1s ease-out forwards;
  }
  
  &-title {
    font-size: 5rem;
    margin-bottom: 1.5rem;
    line-height: 1.1;
    
    .highlight {
      background: linear-gradient(120deg, var(--color-primary) 0%, var(--color-secondary) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      font-weight: 800;
    }
  }
  
  &-subtitle {
    font-size: 2rem;
    margin-bottom: 2.5rem;
    color: var(--color-secondary);
    font-weight: 500;
    opacity: 0;
    animation: fadeIn 0.8s ease-out 0.5s forwards;
  }
  
  &-cta {
    display: flex;
    gap: 1.5rem;
    justify-content: center;
    opacity: 0;
    animation: fadeIn 0.8s ease-out 1s forwards;
    
    .btn {
      padding: 1rem 2rem;
      font-size: 1.1rem;
      transform: scale(1);
      transition: all 0.3s ease;
      
      &:hover {
        transform: scale(1.05);
        background-color: var(--color-secondary) !important;
        color: white !important;
      }
    }
    
    @media (max-width: 480px) {
      flex-direction: column;
      align-items: center;
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(2rem);
  }
  to {
    opacity: 1;
    transform: translateY(-2rem);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .hero {
    &-title {
      font-size: 3.5rem;
    }
    
    &-subtitle {
      font-size: 1.5rem;
    }
    
    &-content {
      padding: 2rem;
    }
  }
}
</style>